<template>
  <b-card no-body class="card-profile mt-8">
    <b-row class="justify-content-center">
      <b-col lg="3" class="order-lg-2">
        <div class="card-profile-image">
          <a href="#">
            <b-img src="/img/theme/default-avatar.jpg" rounded="circle" />
          </a>
        </div>
      </b-col>
    </b-row>
    <b-card-header class="text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">

    </b-card-header>
    <b-card-body>
      <div class="text-center mt-4" v-if="!editable">
        <h5 class="h3">
          {{ form.name }}
        </h5>
        <div class="h5 font-weight-300">
          <i class="ni location_pin mr-2"></i>{{ form.title }}
        </div>
        <div class="h5 mt-4">
          <i class="ni business_briefcase-24 mr-2"></i>{{ form.email }}
        </div>
        <div>
          <i class="ni education_hat mr-2"></i>{{ form.phone }}
        </div>
        <div class="mb-4">
          <i class="ni education_hat mr-2"></i>{{ form.city }}, {{ form.state }}
        </div>

        <base-button block type="danger" @click="toggleEdit">Edit</base-button>
      </div>
      <div class="mb-2" v-else>
        <validation-observer v-slot="{handleSubmit, errors}" ref="formValidator">
          <form class="needs-validation" ref="transactionForm"
                @submit.prevent="handleSubmit(update)">
            <base-input label="Name"
                        name="Name"
                        rules="required"
                        v-model="form.name">
            </base-input>

            <base-input label="Title"
                        name="Title"
                        v-model="form.title">
            </base-input>

            <base-input label="Email"
                        name="Email"
                        rules="required"
                        v-model="form.email">
            </base-input>

            <base-input type="tel"
                        label="Phone"
                        name="Phone"
                        rules="required"
                        v-model="form.phone">
            </base-input>

            <base-input label="City"
                        name="City"
                        rules="required"
                        v-model="form.city">
            </base-input>

            <base-input label="State"
                        name="State"
                        rules="required"
                        v-model="form.state">
            </base-input>

            <base-button block type="success" native-type="submit">Save</base-button>
            <base-button block type="danger" @click="toggleEdit">Cancel</base-button>
          </form>
        </validation-observer>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import axios from 'axios';
import errorsMixin from '@/mixins/errors-mixin';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';

export default {
  mixins: [errorsMixin],
  data: function() {
    return {
      form: null,
      editable: false
    }
  },
  computed: {
    user() {
      return this.$store.getters['profile/user'];
    },
    userRoute() {
      return this.$store.getters['profile/userRoute'];
    },
    avatar() {
      return 'https://d2s6zp8bh3yhqp.cloudfront.net/' + this.$store.getters['profile/avatar'];
    }
  },
  methods: {
    updateForm() {
      this.form = this.user;
    },
    toggleEdit() {
      this.editable = (this.editable) ? false : true;
    },
    async update() {
      axios.patch(this.userRoute, this.form)
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.editable = false;
        });
      })
      .catch(error => {
        this.error(error);
      });
    }
  },
  created() {
    this.updateForm();
  }
};
</script>